<template>
  <DashboardTemplate :navMenu="true">
    <div v-loading="loading">
      <div class="text-left pd-b-3">
        <h2 class="mg-less">เพิ่มผู้สอน</h2>
      </div>

      <div class="pd-b-3  out-box-image pd-x-4">
        <el-upload
          action="#"
          :class="getUrlImage(image)?'box-image-upload-profile':'box-image-upload'"
          ref="upload"
          list-type="picture-card"
          :auto-upload="false"
          :on-change="uploadImage"
        >
          <div v-if="getUrlImage(image)" class="preview">
            <avatar
              :rounded="false"
              username="N"
              :src="`${getUrlImage(image)}`"
              :size="160"
              class="set-img"
            ></avatar>
            <span v-if="getUrlImage(image)" class="icon">
              <i class="fas fa-1x fa-camera"></i>
            </span>
          </div>
          <div v-else slot="default">
            <span class="icon">
              <i class="fas fa-1x fa-camera"></i>
              <p>อัพโหลดรูปภาพ</p>
            </span>

            <div class="preview">
              <avatar
                v-if="showProfile"
                :rounded="false"
                :username="''"
                :src="getUrlImage(image)"
                :size="150"
              >
              </avatar>
            </div>
          </div>
        </el-upload>
      </div>
      <div>
        <InstructorForm @createInstructor="createInstructor" />
      </div>
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import InstructorForm from "@/components/instructor/InstructorForm";
import { HTTP } from "@/service/axios.js";
import Avatar from "vue-avatar";

export default {
  components: {
    DashboardTemplate,
    InstructorForm,
    Avatar
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      loading: false,
      image: null,
      showProfile: true,
    };
  },
  methods: {
    uploadImage(file) {
      this.showProfile = false;
      this.image = file;
      setTimeout(() => {
        this.showProfile = true;
      }, 100);
    },
    getUrlImage(image) {
      if (image != null) {
        return URL.createObjectURL(image.raw);
      } else {
        return "";
      }
    },
    createInstructor(data, countryCode) {
      this.loading = true;
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();

      if (this.image) {
        formData.append("file", this.image.raw);
      }

      formData.append("email", data.email);
      formData.append("nameTH", data.nameTh);
      formData.append("surnameTH", data.lastNameTh);
      formData.append("nameEN", data.nameEn);
      formData.append("surnameEN", data.lastNameEn);
      formData.append("titleName", data.prefix);
      formData.append("countryCode", data.countryCode);
      formData.append("mobilephone", data.phoneNumber);
      formData.append("position", data.position);
      formData.append("password", data.password);

      let institution = {
        name: data.organization,
        address: data.address,
        postcode: data.postcode,
        subdistrict: data.subDistrict,
        district: data.district,
        province: data.province,
      };

      formData.append("institution", JSON.stringify(institution));

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`instructor`, formData, config)
        .then((res) => {

          if (res.data.success) {
            this.$router.push("/instructor/list");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("updateMessage error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
